import { Helper } from '../../Helper';
export class PackObjectHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitOp(node, 'PACK');
            sb.emitHelper(node, options, sb.helpers.wrapObject);
        }
    }
}

//# sourceMappingURL=PackObjectHelper.js.map
